import { useState, useEffect, useRef } from "react";
import { Eventbus } from "../../../utils/index";
import { events } from "../../../utils/constants/index";
import { getSignalRConnectionState } from "../../../services/signalR.service";

// Hook to track SignalR connection status
function useWebSocketPing() {
  const [connected, setConnected] = useState(false);
  const initializedRef = useRef(false);
  useEffect(() => {
    // Check current connection state on mount
    if (initializedRef.current) {
      return;
    }
    setConnected(getSignalRConnectionState());

    const handleConnected = () => {
      setConnected(true);
    };

    const handleDisconnected = () => {
      setConnected(false);
    };

    Eventbus.on(events.SIGNALR.CONNECTED, handleConnected);
    Eventbus.on(events.SIGNALR.DISCONNECTED, handleDisconnected);
    initializedRef.current = true;
    return () => {
      Eventbus.off(handleConnected);
      Eventbus.off(handleDisconnected);
    };
  }, []);

  return connected;
}

export default useWebSocketPing;